import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { BASE_URL, CreateMessageDto, MessageDto } from './api.clients.generated';

@Injectable({ providedIn: 'root' })
export class BackofficeMessageUploadService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(BASE_URL, { optional: true }) ?? '';

  createInternalMessageWithAttachments(
    message: CreateMessageDto,
    files: File[]
  ): Observable<MessageDto> {
    const formData = new FormData();
    formData.append(
      'message',
      new Blob([JSON.stringify(message.toJSON())], { type: 'application/json' })
    );

    for (const file of files) {
      formData.append('files', file, file.name);
    }

    return this.http
      .post<unknown>(`${this.baseUrl}/api/backoffice/v1/messages-with-attachments`, formData)
      .pipe(map(response => this.toMessage(response)));
  }

  private toMessage(response: unknown): MessageDto {
    const payload = (response ?? {}) as {
      message?: unknown;
    };

    return MessageDto.fromJS(payload.message ?? payload);
  }
}